import React, { useEffect, useRef, useState } from 'react';
import ChatHeader from './ChatHeader';
import './ChatWindow.css';
import MessageInput from './MessageInput';
import MessageList from './MessageList';

const ChatWindow = ({ messages, onSendMessage, botName, botAvatar, user, onSignOut }) => {
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = () => {
    if (inputValue.trim()) {
      onSendMessage(inputValue);
      setInputValue('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chat-window">
      <ChatHeader 
        botName={botName} 
        botAvatar={botAvatar} 
        user={user}
        onSignOut={onSignOut}
      />
      <MessageList 
        messages={messages} 
        botAvatar={botAvatar}
        messagesEndRef={messagesEndRef}
      />
      <MessageInput
        value={inputValue}
        onChange={setInputValue}
        onSend={handleSend}
        onKeyPress={handleKeyPress}
      />
    </div>
  );
};

export default ChatWindow;

